import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config/api';
import TenantLayout from '../components/TenantLayout';
import { useSite } from '../context/SiteContext';

const TenantBookings = () => {
  const { selectedSite, updateTrigger } = useSite();
  const [bookings, setBookings] = useState([]);

  useEffect(() => {
    fetchBookings();
  }, [selectedSite, updateTrigger]);

  const fetchBookings = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_BASE_URL}/api/bookings`, {
        headers: { 
          Authorization: `Bearer ${token}`,
          'x-tenant-id': '68fbc468677e7e1d89957085'
        }
      });
      let allBookings = response.data.bookings || [];
      
      // Filter by selected site
      if (selectedSite && selectedSite !== 'all') {
        allBookings = allBookings.filter(booking => {
          // Check if booking's ticket belongs to selected site
          return booking.ticketTypeId?.siteId === selectedSite;
        });
        console.log(`Filtered bookings by site ${selectedSite}:`, allBookings.length);
      }
      
      setBookings(allBookings);
    } catch (error) {
      console.error('Error fetching bookings:', error);
      setBookings([]);
    }
  };

  const getStatusColor = (status) => {
    switch(status) {
      case 'confirmed': return 'linear-gradient(45deg, #10b981, #059669)';
      case 'pending': return 'linear-gradient(45deg, #f59e0b, #d97706)';
      case 'cancelled': return 'linear-gradient(45deg, #ef4444, #dc2626)';
      default: return '#718096';
    }
  };

  return (
    <TenantLayout>
      <div style={{ padding: '20px' }}>
        <div style={{ marginBottom: '30px' }}>
          <h1 style={{ margin: '0 0 10px 0', color: '#2d3748', fontSize: '28px' }}>Bookings Management</h1>
          <p style={{ color: '#718096', margin: 0 }}>View and manage all ticket bookings</p>
        </div>

        <div style={{ background: 'white', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', overflow: 'hidden', border: '1px solid #e2e8f0' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead style={{ background: 'linear-gradient(45deg, #14b8a6, #0d9488)' }}>
              <tr>
                <th style={{ padding: '12px', textAlign: 'left', color: 'white', fontWeight: '600' }}>Booking ID</th>
                <th style={{ padding: '12px', textAlign: 'left', color: 'white', fontWeight: '600' }}>Site</th>
                <th style={{ padding: '12px', textAlign: 'left', color: 'white', fontWeight: '600' }}>Customer</th>
                <th style={{ padding: '12px', textAlign: 'left', color: 'white', fontWeight: '600' }}>Tickets</th>
                <th style={{ padding: '12px', textAlign: 'left', color: 'white', fontWeight: '600' }}>Amount</th>
                <th style={{ padding: '12px', textAlign: 'left', color: 'white', fontWeight: '600' }}>Status</th>
                <th style={{ padding: '12px', textAlign: 'left', color: 'white', fontWeight: '600' }}>Date & Time</th>
                <th style={{ padding: '12px', textAlign: 'left', color: 'white', fontWeight: '600' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {bookings.map(booking => (
                <tr key={booking._id}>
                  <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>{booking.bookingId || booking._id.slice(-6)}</td>
                  <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>{booking.ticketTypeId?.name || 'N/A'}</td>
                  <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>{booking.userId?.name || booking.customerName || 'N/A'}</td>
                  <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>{booking.quantity}</td>
                  <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>₹{booking.totalAmount}</td>
                  <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>
                    <span style={{
                      background: getStatusColor(booking.status),
                      color: 'white',
                      padding: '4px 8px',
                      borderRadius: '4px',
                      fontSize: '12px'
                    }}>
                      {booking.status}
                    </span>
                  </td>
                  <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>
                    {new Date(booking.createdAt).toLocaleDateString()}<br/>{new Date(booking.createdAt).toLocaleTimeString()}
                  </td>
                  <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>
                    <button style={{
                      background: 'linear-gradient(45deg, #14b8a6, #0d9488)',
                      color: 'white',
                      border: 'none',
                      padding: '6px 12px',
                      borderRadius: '6px',
                      fontSize: '12px',
                      cursor: 'pointer',
                      fontWeight: '600'
                    }}>
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {bookings.length === 0 && (
          <div style={{
            textAlign: 'center',
            padding: '60px 20px',
            background: 'linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%)',
            borderRadius: '16px',
            border: '1px solid #a7f3d0'
          }}>
            <div style={{ fontSize: '4rem', marginBottom: '16px' }}>📋</div>
            <h3 style={{ color: '#065f46', marginBottom: '8px' }}>No bookings found</h3>
            <p style={{ color: '#047857' }}>No bookings found for selected site</p>
          </div>
        )}
      </div>
    </TenantLayout>
  );
};

export default TenantBookings;